import { Component, Input, HostBinding } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-pinterest-modal',
  styleUrls: ['./pinterest.component.less'],
  templateUrl: './pinterest.component.html',
})
export class EditPinterestModalComponent {
  @Input() close: Function;
  @HostBinding('class._is-discovered') isDiscovered = false;
  url = '';
  urlCtrl: FormControl = new FormControl('', [Validators.required]);

  submit() {
    if (this.urlCtrl.hasError('required') || this.urlCtrl.hasError('pattern')) {
      return;
    }

    this.isDiscovered = true;
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/integrations/pinterest/pinterest.component.ts